import { useTranslation } from "react-i18next"

import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"

import { useTranslationInstructions } from "../hooks/use-translation-instructions"

export function TranslationInstructionsInput() {
  const { t } = useTranslation()

  const { handleChangeInstructions, translationInstructions } = useTranslationInstructions()

  return (
    <section className="flex w-full flex-col gap-1">
      <Tooltip>
        <TooltipTrigger className="w-full text-left">
          <Label>{t("pages.translate.custom_instructions")}</Label>
        </TooltipTrigger>
        <TooltipContent className="max-w-[250px]" side="left">
          <p>{t("pages.translate.instructions_tooltip")}</p>
        </TooltipContent>
      </Tooltip>

      <Input
        placeholder={t("pages.translate.instructions_placeholder")}
        value={translationInstructions}
        onChange={handleChangeInstructions}
      />
    </section>
  )
}
